import { ChangeDetectionStrategy, Component } from '@angular/core'
import { BaseEventTicketsFacade } from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.facade'
import * as BaseEventTicketsActions from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.actions'
import { EventTicketGuestStepperPayload } from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.models'
import { GbCookieService } from 'libs/shared/utils/services/src/lib/gb-cookie/gb-cookie.service'

@Component({
  selector: 'gb-event-ticket-assign-dialog',
  templateUrl: './gb-event-ticket-assign-dialog.component.html',
  styleUrls: ['./gb-event-ticket-assign-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbEventTicketAssignDialogComponent {
  selectedEventTicket$ = this.baseEventTicketsFacade.selectedEventTicket$

  get isAdminOrVolunteer(): boolean {
    return this.gbCookieService.isAdminOrVolunteer()
  }

  constructor(private baseEventTicketsFacade: BaseEventTicketsFacade, private gbCookieService: GbCookieService) {}

  onSubmit(stepperPayload: EventTicketGuestStepperPayload): void {
    this.baseEventTicketsFacade.dispatch(
      BaseEventTicketsActions.assignEventTicket({
        payload: {
          ...stepperPayload.profile,
          self_assign: stepperPayload.isSelfAssigned,
          custom_values: stepperPayload.customValues,
        },
      }),
    )
  }
}
